export interface Lagerplatz {
  id: number;
  barcode: string | null;
  lagerplatz: string;
}
